<template>
  <div>
    <div style="max-height: 57vh; overflow: auto;">
      <table class="table text-left table-hover table-bordered table-vertical-center b-table">
        <thead style="position: sticky; top: 0; z-index: 10">
        <tr style="background-color: #472F92; color: white">
          <th style="width: 50px">STT</th>
          <th style="width: 200px">Tên KRA</th>
          <th style="width: 250px">Nội dung cũ</th>
          <th style="width: 250px">Nội dung mới</th>
          <th class="text-center" style="width:50px">
            <el-checkbox v-model="approveAll" />
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-if="kraByUserClone?.length > 0">
          <tr v-for="(item, index) in kraByUserClone" :key="item.id">
            <td class="text-center">{{ index + 1 }}</td>
            <td>
              <span>{{ item.name ?? '' }}</span>
            </td>
            <td>
              <div class="display-col" v-if="item.oldContent">
                <strong>KRA: <span v-html="item.oldName"></span></strong>
                <span>Yêu cầu thành phẩm:</span>
                <span v-html="item.oldResult"></span>
                <span>Trọng số: <span v-html="item.oldPercent"></span><span style="color: green;">%</span></span>
                <span>Thời gian: <span v-html="item.oldHour"></span></span>
              </div>
            </td>
            <td>
              <div class="display-col" v-if="item.newContent">
                <strong>KRA: <span v-html="item.newName"></span></strong>
                <span>Yêu cầu thành phẩm:</span>
                <span v-html="item.newResult"></span>
                <span>Trọng số: <span v-html="item.newPercent"></span><span style="color: green;">%</span></span>
                <span>Thời gian: <span v-html="item.newHour"></span></span>
              </div>
            </td>
            <td class="text-center">
              <el-checkbox v-model="item.selected" :disabled="item.disabled"/>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="5" class="text-center">Chưa có dữ liệu</td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-end pt-4">
      <el-button
          :disabled="disabledSubmit"
          type="danger" style="color: white;"
          @click="handleConfirm(2)"
      >
        Từ chối
      </el-button>
      <el-button
          :disabled="disabledSubmit"
          type="primary"
          style="color: white; background: #472F92"
          @click="handleConfirm(1)"
      >
        Duyệt
      </el-button>
    </div>
    <el-dialog
        class="responsive" width="40%" v-if="isConfirm"
        :visible.sync="isConfirm" append-to-body
        :title="`Xác nhận ${type === 1 ? 'duyệt' : 'từ chối'} KRA`"
    >
      <hr style="margin-top: -20px; margin-bottom: 20px; border: 1px solid lightgray"/>
      <span style="word-break: break-word">
        Bạn sẽ không thể thay đổi sau khi {{type === 1 ? 'duyệt' : 'từ chối'}} kra. Vui lòng xác nhận !
      </span>
      <div class="d-flex justify-content-end mt-4">
        <el-button
            :disabled="loading"
            v-loading="loading"
            type="primary"
            style="color: white; background: #472F92"
            @click="handleApproveKra"
        >
          Xác nhận
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { KRA_APPROVE } from "@/core/services/store/okrs/okr.module";

export default {
  name: 'TableKraByUser',
  props: {
    kraByUser: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      approveAll: false,
      type: null,
      isConfirm: false,
      kraByUserClone: [],
      loading: false,
    }
  },
  computed: {
    disabledSubmit() {
      return this.kraByUserClone.filter(item => item.selected).length === 0
    }
  },
  watch: {
    approveAll(newVal, oldVal) {
      this.kraByUserClone = this.kraByUserClone.map(item => {
        return {
          ...item,
          selected: item.status !== 0 ? false : this.approveAll
        }
      })
    },
    kraByUser: {
      immediate: true,
      handler(newVal) {
        this.kraByUserClone = [...newVal]
      }
    }
  },
  methods: {
    handleConfirm(type) {
      this.isConfirm = true
      this.type = type
    },

    handleApproveKra() {
      this.loading = true
      const payload = {
        kra_change_ids: this.kraByUserClone.filter(item => item.selected).map(kra => kra.id),
        status: this.type,
      }
      this.$store.dispatch(KRA_APPROVE, payload).then(res => {
        if (!res.error) {
          this.$message.success(`${this.type === 1 ? 'Duyệt' : 'Từ chối'} kra thành công!`)
          this.$emit('closeDialog')
          this.$emit('getListKraByUser')
          this.isConfirm = false
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.loading = false)
    },
  },
}
</script>

<style scoped>
.display-col {
  display: flex;
  flex-direction: column;
}
</style>